import Header from "./Header"
import Footer from "./Footer"
export default {
    install(Vue) {
      // 注册组件
      Vue.component('Header', Header)
	  Vue.component('Footer', Footer)
    }
  }
  